<template>
  <div class="home">
    <about></about>
    <report-infestation-form></report-infestation-form>
    <pest-map name="ants"></pest-map>
    <contact-us></contact-us>
  </div>
</template>

<script>
import About from '@/components/About'
import ReportInfestationForm from '@/components/ReportInfestationForm'

import PestMap from '@/components/PestMap'
import ContactUs from '@/components/ContactUs'

export default {
  name: 'home',
  components: {
    About,
    ReportInfestationForm,
    PestMap,
    ContactUs
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue